/**
 * Airframe type for the AFF panels and grid (#798).
 *
 * Selkirk publishes it as `resourceSubclass`, spelled out — "Fixed Wing",
 * "Rotary Wing" — and the Aviation group asked for the abbreviations they use,
 * FW and RW.
 *
 * The value was discarded before storage until the collector change shipped,
 * which is why the panel could not show an airframe type and the map icons
 * infer one from other signals instead.
 */

const CODES: Record<string, string> = {
  'fixed wing': 'FW',
  'rotary wing': 'RW',
};

/**
 * The abbreviation for a reported airframe type, the value itself where it is
 * not one we know, or null where none was reported.
 *
 * An unrecognised type reads as it arrived rather than being abbreviated on a
 * guess: inventing a code would state something Selkirk never told us, and
 * blanking it would hide that the aircraft has a type at all. Matching is
 * loose on case, surrounding space and the hyphen, since those vary by
 * provider and none of them change what was meant.
 */
export const airframeCode = (subclass: string | null | undefined): string | null => {
  if (typeof subclass !== 'string') return null;

  const trimmed = subclass.trim();
  if (trimmed === '') return null;

  const normalised = trimmed.toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');
  return CODES[normalised] ?? trimmed;
};
